<template>
  <path
    d="M7.22247 5.19284L9.79026 7.53762C10.0699 7.79298 10.0699 8.20702 9.79026 8.46238L7.22246 10.8072C6.77134 11.2191 6 10.9274 6 10.3448L6 5.65522C6 5.07265 6.77135 4.7809 7.22247 5.19284Z" />
</template>
